import { toast } from "sonner";

/**
 * 操作が通ったことを知らせるトースト。
 *
 * 直接 `toast.success` を呼ばずここを通すのは、
 * - 出し方（位置・色・duration）を 1 箇所で決めるため。`Toaster` は
 *   `app/providers.tsx` に 1 つだけ置いてある
 * - テストで `sonner` ごと mock せず、この関数の呼び出しだけを見れば済むため
 *
 * 文言は呼び出し側が `t()` で解決して渡す（i18n の名前空間は画面ごとに違うため）。
 * 失敗の表示はトーストにしない。原因と再試行の導線が要るので、その場に
 * `role="alert"` で出す（消えるトーストだと読み落とす）。
 */
export function notifySuccess(message: string): void {
  if (message === "") return;

  toast.success(message);
}
